import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { INotificationData } from '@/interfaces/notification';

interface IState {
  notification: INotificationData | null;
}

const initialState: IState = {
  notification: null
};

export const notificatioSlice = createSlice({
  name: 'notificatioSlice',
  initialState,
  reducers: {
    setNotification(state, { payload }: PayloadAction<INotificationData>) {
      return {
        ...state,
        notification: payload
      };
    }
  }
});

export const { setNotification } = notificatioSlice.actions;

export default notificatioSlice.reducer;
